import { useCallback } from 'react';
import { useFunnelsApiFacade } from '../apis/facades/useFunnelsApiFacade';

export const useIsFunnelNameUnique = () => {
  const { get_funnelNameAvailability } = useFunnelsApiFacade();
  const isFunnelNameUnique = useCallback(
    async ({
      funnelId,
      name,
      objectName,
    }: {
      funnelId?: string;
      name: string;
      objectName: string;
    }) => {
      const { available } = await get_funnelNameAvailability({
        funnelName: name,
        objectName,
        funnelId,
      });
      return available;
    },
    [get_funnelNameAvailability],
  );

  return isFunnelNameUnique;
};
